module.exports = __webpack_public_path__ + "img/Flag_of_Jersey.7e05a75a.svg";